/**
 * Per-page docs media (screenshots + short autoplay clips), keyed by page slug.
 *
 * Kept separate from `content.ts` on purpose: media is NOT part of a page's
 * translation source (`getDocsSourceHash` hashes only title/description/overview),
 * so attaching it here adds screenshots to every locale at once without marking
 * any translation stale. Paths use the `/docs-imgs/...` prefix and resolve via
 * `docsAsset()`. Assets are hosted on Supabase Storage (shared with the public
 * Learn site); `.mp4/.webm/.mov` render as muted autoplay-loop clips, everything
 * else as a click-to-zoom image.
 */
export const DOCS_SCREENSHOTS: Record<string, string[]> = {
  // welcome1/welcome2 are embedded inline in the welcome overview (above the
  // "Press V" and "When you have…" paragraphs), so they're not listed here.
  'getting-started/first-shot': ['/docs-imgs/first-shot.png'],
  'getting-started/iterating': ['/docs-imgs/iterate.mp4'],
  'canvas/overview': ['/docs-imgs/canva.png'],
  'canvas/nodes': ['/docs-imgs/canvas-objects.mp4'],
  'canvas/selection': ['/docs-imgs/selection.mp4'],
  'canvas/uploading': ['/docs-imgs/drag-and-drop.mp4'],
  'canvas/organizing': ['/docs-imgs/organizing.mp4'],
  'canvas/clipboard': ['/docs-imgs/copypaste-duplicate1.mp4', '/docs-imgs/copypaste-duplicate2.mp4'],
  'canvas/undo-redo': ['/docs-imgs/undoredo.mp4'],
  'canvas/rename': ['/docs-imgs/renaming.mp4'],
  'canvas/delete': ['/docs-imgs/deleting.mp4'],
  'generation/overview': ['/docs-imgs/generationOverview.png'],
  'generation/images': ['/docs-imgs/generationImages.mp4'],
  'generation/video': ['/docs-imgs/generationVideo.mp4'],
  'generation/models': ['/docs-imgs/generationModels.png'],
  'generation/prompting': ['/docs-imgs/generationPrompt.mp4'],
  // generationUpscale.mp4 is embedded inline in the upscaling overview (below the
  // intro paragraph), so it's not listed here.
  'generation/credits': ['/docs-imgs/generationOlives.mp4'],
  'sets/overview': ['/docs-imgs/setsOverview1.png', '/docs-imgs/setsOverview2.png'],
  'sets/creating': ['/docs-imgs/setsCreating.mp4'],
  'sets/characters': ['/docs-imgs/sets-characters.png'],
  'sets/viewer': ['/docs-imgs/setviewer.mp4'],
  'timeline/overview': ['/docs-imgs/timelineOverview.png'],
  'timeline/clips': ['/docs-imgs/timelineShotsandtracks.mp4'],
  'timeline/audio': ['/docs-imgs/timelineAudio.png'],
  'timeline/playback': ['/docs-imgs/playback.mp4'],
  'timeline/sequences': ['/docs-imgs/timelineSequence.mp4'],
  'export/overview': ['/docs-imgs/exportOverview.png'],
  'export/mp4': ['/docs-imgs/exportMp4.mp4'],
  'export/nle': ['/docs-imgs/exportXML.mp4'],
  'teams/overview': ['/docs-imgs/teamOverview.png'],
  'teams/members': ['/docs-imgs/teaMemb.png'],
  'teams/billing': ['/docs-imgs/teambilling.png'],
  'teams/models': ['/docs-imgs/teaModel.png'],
  'account/profile': ['/docs-imgs/accProfile.png'],
  'account/preferences': ['/docs-imgs/accPreference.png'],
  'account/billing': ['/docs-imgs/accBilling.png'],
}
